import { isNaN } from "lodash";

export const MS_PER_DAY = 1000 * 60 * 60 * 24;

export const isValidDate = (d: Date): boolean => {
  return !isNaN(d) && d.toDateString().toLowerCase() !== "invalid date";
};

export const dateDiffDays = (a: Date, b: Date) => {
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  if (utc1 > utc2) return Math.floor((utc1 - utc2) / MS_PER_DAY);
  return Math.floor((utc2 - utc1) / MS_PER_DAY);
};

export const dateIsInPast = (d: Date) => {
  return d < new Date();
};
